import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await (window as any).Clerk?.session?.getToken({ template: 'fisiolab-sudo' });
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (process.env.NODE_ENV !== 'production') {
    console.warn('[apiClient] Clerk token null — request sin Authorization:', config.url);
  }
  return config;
});

export default apiClient;
